module.exports = __webpack_public_path__ + "media/icons/user-328c532a.svg";